// extracted by mini-css-extract-plugin
export var content = "_6t-3";
export var list = "_6t-4";
export var settingsContent = "_6t-7";
export var settingsPanel = "_6t-8";
export var state = "_6t-6";
export var triggerBadge = "_6t-2";
export var triggerButton = "_6t-1";
export var triggerShell = "_6t-0";
export var unreadDot = "_6t-5";